import TitleInput from 'components/common/TitleInput/TitleInput'
import { APP_LANGUAGES } from 'constants/index'
import React from 'react'
import PropTypes from 'prop-types'
import { TextField } from '@material-ui/core'
import { injectIntl } from 'react-intl'

function PreviewInputsForm({
  previewInputs,
  setPreviewInputs,
  submitting,
  previewPositionProperty,
  intl: { formatMessage },
}) {
  const handleShortNameClear = (index, key) => {
    const updatedInputs = previewInputs.map((input, idx) => {
      if (index === idx) {
        return { ...input, short_name: { ...input.short_name, [key]: '' } }
      }

      return input
    })

    setPreviewInputs(updatedInputs)
  }

  const handleShortNameChange = (index, key, { target: { value } }) => {
    const updatedInputs = previewInputs.map((input, idx) => {
      if (index === idx) {
        return { ...input, short_name: { ...input.short_name, [key]: value } }
      }

      return input
    })

    setPreviewInputs(updatedInputs)
  }

  const handlePositionChange = (index, { target: { value } }) => {
    const updatedInputs = previewInputs.map((input, idx) => {
      if (index === idx) {
        return { ...input, [previewPositionProperty]: value }
      }

      return input
    })

    setPreviewInputs(updatedInputs)
  }
  if (previewInputs.length) {
    return (
      <div className="preview-block-workflow">
        <div className="preview-title">Previews</div>
        {previewInputs.map(({ id, title, short_name, ...rest }, index) => (
          <div className="preview-item" key={`${id}-preview-item`}>
            <TitleInput
              handleTitleClear={() => {}}
              formState={previewInputs[index].title}
              disabled>
              {Object.values(APP_LANGUAGES).map(({ key }) => (
                <TextField
                  className="preview-input"
                  key={`${id}-${key}-title`}
                  label={`${key} ${formatMessage({
                    id: 'title',
                  })}`}
                  type="text"
                  lang={key}
                  value={title[key]}
                  disabled
                />
              ))}
            </TitleInput>
            <TitleInput
              handleTitleClear={value => handleShortNameClear(index, value)}
              formState={previewInputs[index].short_name}
              backgroundButton>
              {Object.values(APP_LANGUAGES).map(({ key }) => (
                <TextField
                  className="preview-input"
                  key={`${id}-${key}-short-name`}
                  label={`${key} ${formatMessage({
                    id: 'short_title',
                  })}`}
                  name={`short_name[${key}]`}
                  disabled={submitting}
                  type="text"
                  lang={key}
                  value={short_name[key]}
                  onChange={e => handleShortNameChange(index, key, e)}
                />
              ))}
            </TitleInput>
            <TextField
              className="preview-input"
              key={`${id}-preview-position`}
              label={formatMessage({ id: 'position' })}
              name="preview_position"
              disabled={submitting}
              value={rest[previewPositionProperty]}
              type="number"
              onChange={e => handlePositionChange(index, e)}
            />
          </div>
        ))}
      </div>
    )
  }

  return <div />
}

PreviewInputsForm.propTypes = {
  previewInputs: PropTypes.array.isRequired,
  setPreviewInputs: PropTypes.func.isRequired,
  submitting: PropTypes.func.isRequired,
}

export default injectIntl(PreviewInputsForm)
